import { Languages } from '../constants/languages';
import { ChineseStatements } from './chinese-statements';
import { EnglishStatements } from './english-statements';
import { FrenchStatements } from './french-statements';
import { GermanStatements } from './german-statements';
import { JapaneseStatements } from './japanese-statements';
import { SpanishStatements } from './spanish-statements';
import { StatementType } from './statement-types';

/**
 * All statements for all supported languages
 */
export const statements: Record<Languages, Record<StatementType, string[]>> = {
  english: EnglishStatements,
  chinese: ChineseStatements,
  french: FrenchStatements,
  spanish: SpanishStatements,
  german: GermanStatements,
  japanese: JapaneseStatements,
};

/**
 * Get a random message for the given tone level and language.
 *
 * @param toneLevel the tone level to get a message for
 * @param language the language to get a message in
 * @returns a random message for the given tone level and language
 */
export function getMessageForTone(toneLevel: StatementType, language: Languages): string {
  const messages = statements[language][toneLevel];
  if (!messages || messages.length === 0) {
    return '';
  }
  // Return a random message for the given tone level
  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
}
